/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Voltar',
    SCAN_QR_CODE: 'Ler QR code'
  },
  ERRORS: {
    GET_DOCUMENT: 'Não foi possível obter o documento.',
    INVALID_CODE: 'Código inválido.',
    VALIDATING_CODE: 'Não foi possível validar o código.'
  },
  LABELS: {
    DELIVERY_ORDER: 'Pedido de entrega',
    ERROR: 'Erro',
    OR: 'Ou',
    PACKAGE: 'Caixa',
    TRACKING_OR_CODE: 'N.º de tracking ou código da caixa'
  }
};
